/** Basis-Texte (en). Neue Inhalte liegen in src/i18n/content/en/. */
const data = {
    "navigation": {
        "allWatchfaces": "All Apps",
        "helpCenter": "Help & Instructions",
        "newsletter": "Newsletter",
        "contact": "Contact"
    },
    "homepage": {
        "loading": "Loading watchfaces...",
        "error": "Error loading",
        "retry": "Try again"
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Subscribe to receive updates about new watchfaces, features, and promotions.",
        "frequencyHint": "Roughly one email every two months. You can unsubscribe at any time.",
        "emailPlaceholder": "Your email address",
        "subscribe": "Subscribe",
        "unsubscribe": "Unsubscribe",
        "subscribeSuccess": "Successfully subscribed! Please check your email.",
        "subscribeError": "An error occurred. Please try again later.",
        "unsubscribeSuccess": "Successfully unsubscribed.",
        "unsubscribeError": "An error occurred. Please try again later."
    },
    "contact": {
        "title": "Contact",
        "description": "Have a question or need support? Send me a message.",
        "emailLabel": "Email",
        "emailPlaceholder": "your@email.com",
        "deviceLabel": "Device (optional)",
        "devicePlaceholder": "e.g. Fenix 7",
        "watchfaceLabel": "Watchface (optional)",
        "watchfacePlaceholder": "e.g. Horizon",
        "messageLabel": "Message",
        "messagePlaceholder": "Your message...",
        "send": "Send Message",
        "sendAnother": "Send another message",
        "successTitle": "Message sent!",
        "successMessage": "I will get back to you as soon as possible.",
        "error": "An error occurred. Please try again or email dev@orcatec.net directly.",
        "rateLimit": "Maximum 2 messages per 5 minutes. Please try again later.",
        "faqLinkLabel": "Open Help & Instructions",
        "responseTimeNotice": "Please understand that during busy times it can sometimes take several days until I can reply."
    },
    "refund": {
        "title": "Refund Policy"
    },
    "terms": {
        "title": "Terms of Service"
    },
    "privacy": {
        "title": "Privacy Notice"
    },
    "footer": {
        "description": "Modern Garmin apps with advanced features for all activities.",
        "tagline": "Modern Garmin apps with advanced features for all activities.",
        "linksTitle": "Links",
        "socialsTitle": "Socials",
        "terms": "Terms of Service",
        "impressum": "Imprint",
        "privacy": "Privacy",
        "refund": "Refund Policy",
        "contact": "Contact",
        "rights": "All rights reserved.",
        "links": "Links",
        "contactDescription": "Questions or Support?",
        "contactLink": "Get in touch",
        "copyright": "Orcatec - TitanicTurtle. All rights reserved.",
        "garminForums": "Garmin Forums"
    },
    "common": {
        "notFound": "404 – Page not found"
    },
    "watchfaceDetail": {
        "loading": "Loading watchface..."
    },
    "payment": {
        "tax": "tax",
        "wfid": {
            "guideLink": "How to find your WatchfaceID"
        },
        "wfidError": {
            "letters": "WatchfaceID should only contain numbers",
            "lengthHint": "A WatchfaceID is usually 5-6 digits. Please double-check."
        },
        "errors": {
            "empty": "Please enter your WatchfaceID",
            "config": "Payment configuration error",
            "checkout": "Failed to open checkout. Please try again."
        },
        "buy": "Buy Now",
        "beta": {
            "title": "Currently in Beta",
            "description": "During this beta phase, you can use this watchface completely for free. There will be no automatic charges after the test phase. New features and functions are being tested during this time. Thanks for your feedback!",
            "descriptionApp": "During this beta phase, you can use this app completely for free. There will be no automatic charges after the test phase. New features and functions are being tested during this time. Thanks for your feedback!"
        },
        "elite": {
            "title": "Elite Version"
        },
        "vx": {
            "title": "VX Version"
        }
    },
    "fonts": {
        "title": "Fonts",
        "timefonts": "Time Fonts",
        "datafonts": "Data Fonts"
    },
    "bodysurf": {
        "intro": {
            "title": "What is BodySurf?",
            "text": "BodySurf is a Garmin Connect IQ watch app for bodysurfing. It uses GPS to detect when you ride a wave, measures distance and duration of each ride, and gives you a fun title based on how far you went. Sessions are saved as activities with individual laps in Garmin Connect."
        },
        "gps": {
            "title": "Before you start – GPS",
            "text1": "Wait until the watch shows a GPS fix before starting a session. On the start screen you will see \"Searching GPS\" until a signal is available, then \"START to begin\".",
            "text2": "For best accuracy the app uses multi-GNSS / dual-band GPS when your watch supports it. Stand still for a moment near the water if the fix takes a while."
        },
        "start": {
            "title": "Start Screen",
            "startBtn": "Begin a new session once GPS is ready (START = begin session).",
            "menuBtn": "Open settings: How to use and Units (MENU = settings / info).",
            "backBtn": "BACK = exit app"
        },
        "during": {
            "title": "During Activity",
            "detect": "Rides are detected automatically from GPS speed: a ride starts above about 0.9 m/s and ends below about 1.0 m/s. Use BACK to start or stop a ride manually. Short movements under about 2 metres are discarded. Screen taps are ignored during a session.",
            "startBtn": "START = stop / save / resume",
            "backBtn": "BACK = manual ride on/off",
            "live": "While riding you see the current distance, a live title and \"RIDING\". The watch vibrates when a ride ends; the last title and stats stay visible until the next ride starts."
        },
        "stop": {
            "title": "Stop menu",
            "resume": "Resume",
            "save": "Save",
            "discard": "Discard"
        },
        "after": {
            "title": "After Session",
            "summary": "The summary shows session time, rides count, total distance, and your best ride with title and stats.",
            "rides": "Swipe or scroll to see the details of each ride.",
            "finished": "When done: New Session with START or Exit App with BACK."
        },
        "titles": {
            "title": "Ride titles",
            "intro": "Each ride gets a fun title based on distance. The longer the ride, the better the title!",
            "colDistance": "Distance",
            "colTitle": "Title",
            "th0": "Beach Bum",
            "th1": "Sea Cucumber",
            "th2": "Flounder",
            "th3": "Seagull Repellent",
            "th4": "Beach Sheriff",
            "th5": "Surf Patrol",
            "th6": "Wave Rider",
            "th7": "Current Advisor",
            "th8": "Wave Breaker",
            "th9": "Aquaman",
            "th10": "Human Surfboard",
            "th11": "Coastal Legend",
            "th12": "Poseidon"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Saved sessions appear in Garmin Connect with these fields: Ride Distance, Ride Time and Ride Title for each lap, Longest Ride and Longest Ride Time for the session, plus a Riding chart (0/1). Distances are always stored in metres. Each detected ride is stored as a lap."
        },
        "instinct": {
            "title": "Instinct 2, 2X and 3 Solar (MIP)",
            "layout": "On Instinct watches the sub-display shows time, GPS, and ride distance. Use the DOWN button instead of swipe (<< DOWN rides).",
            "menu": "Menu is shown on the left of the start screen. Press START when GPS OK appears in the sub-display."
        },
        "settings": {
            "title": "Settings",
            "units": "Units: switch between metric and imperial for distance and speed on the watch.",
            "info": "Info: onboard help (How to use) for buttons during activity, after session, and on the start screen."
        },
        "supportBefore": "For problems or suggestions please use the",
        "supportLink": "contact form",
        "supportAfter": " – thank you!"
    }
};
export default data;
